// Centralised test IDs
export const HOME = {
  emergentLink: "emergent-link",
  ctaPrimary: "home-cta-primary",
  ctaSecondary: "home-cta-secondary",
  ctaTertiary: "home-cta-tertiary",
};

export const NAV = {
  logo: "nav-logo",
  link: (name) => `nav-link-${name}`,
  adminCta: "nav-admin-cta",
};

export const PUBLIC = {
  propertyCard: (id) => `public-property-${id}`,
  caseStudyCard: (id) => `public-case-${id}`,
  filterAll: "filter-all",
  filterRenovation: "filter-in_renovation",
  filterComing: "filter-coming_soon",
  filterCompleted: "filter-completed",
  filterSold: "filter-sold",
};

export const FORM = {
  field: (name) => `form-${name}`,
  submit: (name) => `form-submit-${name}`,
};

export const AUTH = {
  emailInput: "auth-email",
  passwordInput: "auth-password",
  submit: "auth-submit",
  logout: "auth-logout",
  error: "auth-error",
};

export const ADMIN = {
  sidebarLink: (key) => `admin-link-${key}`,
  stat: (key) => `admin-stat-${key}`,
  createProperty: "admin-create-property",
  generateQueries: "admin-generate-queries",
  saveSearch: "admin-save-search",
  addSource: "admin-add-source",
  saveCmsHome: "admin-save-cms-home",
  computeCalc: "admin-compute-calc",
  saveCalc: "admin-save-calc",
  uploadMedia: "admin-upload-media",
  createCaseStudy: "admin-create-case-study",
  createProject: "admin-create-project",
  pipelineColumn: (s) => `pipeline-col-${s}`,
  propertyRow: (id) => `property-row-${id}`,
  leadRow: (id) => `lead-row-${id}`,
};
